import postAPI from './postAPI.js'

export default async function getAssignmentHistory(taskInstanceId) {
    const data = await postAPI('admin/taskinstances/assignmenthistory', { task_instance_id: taskInstanceId });
    return data;
}
